import { Company } from '../company/company.model';
export class EventForPlanningDto {
  id: string;
  text: string;
  userName?: string;
  userLastName?: string;
  userRoleType?: string;
  type: string;
  dateFrom: number;
  duration: number;
  textColor: string;
  backgroundColor: string;
  leadId: string;
  leadContactName: string;
  company: Company;

  constructor(eventEntityPartial?: Partial<Event>) {
    Object.assign(this, eventEntityPartial);
  }
}
